import {getDefaultCity} from "@hooks/cities";
import {setDefaultCity} from "@models/district";
import {getPricesStates} from "@hooks/prices";
import {getMortgageStates} from "@hooks/mortgage";
import {getRentStates} from "@hooks/rent";
import {getLandAreaStates} from "@hooks/land_area";
import {getInfrastructureAreaStates} from "@hooks/infrastructure_area";
import {getAgeStates} from "@hooks/age";
import {DeedState} from "@hooks/deed";
import {FloorsState} from "@hooks/floors";
import {BedroomsState} from "@hooks/bedrooms";
import {FacilitiesState, handleFacilitiesLists, otherFacilityFilters} from "@hooks/facilities";
import {checkVisibleFilter, handleDealTypeParams} from "@hooks/filters.manager";
import {villaTypesState} from "@hooks/villa_type";
import {DensityState} from "@hooks/density";
import {array_unique, inArray, is_array} from "../helpers/arrays";
import {isEmpty} from "../helpers/helpers";
import {pluckKeyToArray, UpdateSelectionOptions} from "../hooks/selection.options";

let selected_filters = {
    city_id: getDefaultCity(),
};

const handleFilters = (key, value) => {

    if (!inArray(key, ['show', 'selected_range'])) {
        if (value && is_array(value) && value.length) {
            selected_filters[key] = value;
        } else if (value && !is_array(value) && value !== '' && value !== null) {
            selected_filters[key] = (typeof value === "boolean" ? '1' : value);
        } else {
            delete selected_filters[key]
        }

        const rangeItems = ['price', 'mortgage', 'rent', 'infrastructure_area', 'land_area', 'age'];
        if (key === 'deal_type') {
            for (let item of rangeItems) {
                delete selected_filters['min_' + item];
                delete selected_filters['max_' + item]
            }
        }
    }
};

export const initial_state = {
    cities: {options: [], selected_items: []},
    districts: {options: [], selected_items: []},
    deal_type: {options: [], selected_items: []},
    types: {options: [], selected_items: []},
    villa_type: villaTypesState,
    price: getPricesStates(),
    mortgage: getMortgageStates(),
    rent: getRentStates(),
    land_area: getLandAreaStates(),
    infrastructure_area: getInfrastructureAreaStates(),
    age: getAgeStates(),
    deeds: DeedState,
    floors: FloorsState,
    facilities: FacilitiesState,
    bedrooms: BedroomsState,
    loan: {show: false, checked: false},
    has_media: {show: true, checked: false},
    has_video: {show: true, checked: false},
    has_pool: {show: false, checked: false},
    more: {show: false},
    densities: DensityState,
    sorts: [
        {name: 'boosted_at', title: 'بروزترین‌', active: true},
        {name: 'price_asc', title: 'ارزان‌ترین', active: false},
        {name: 'price_desc', title: 'گران‌ترین', active: false},
    ],
    selected_filters: selected_filters,
    loadings: {},
    waiting: {
        city: true,
        district: true,
        deal_type: true,
        types: true,
    },
};

export const FilterReducer = (state, action) => {
    switch (action.type) {
        case "CITIES_OPTIONS":
            const city_id = (typeof action.payload.cities.selected_items[0] !== "undefined" ? action.payload.cities.selected_items[0] : getDefaultCity());

            setDefaultCity(city_id);

            state.cities = action.payload.cities;

            state.waiting = {
                city: false,
                district: true,
                deal_type: true,
                types: true,
            };

            state.loadings = {
                districts: true,
                types: true,
                deal_type: true
            };

            if (isEmpty(action.payload.just_cities) || !action.payload.just_cities) {
                state.loadings = {};

                handleFilters('district_id', action.payload.districts.selected_items);
                const newDistrictsByCity = action.payload.districts;
                newDistrictsByCity.selected_items = pluckKeyToArray(newDistrictsByCity.selected_items, 'value');

                state.districts = newDistrictsByCity;
                state.deal_type = action.payload.deal_type;
                state.types = action.payload.types;

                state.waiting = {
                    city: false,
                    district: false,
                    deal_type: false,
                    types: false,
                };
            }

            const selectedDealType = !isEmpty(state.deal_type.selected_items) ? state.deal_type.selected_items[0] : '';
            const selectedTypes = state.types.selected_items;

            const cityChangeParams = {
                city_id: city_id,
                deal_type: selectedDealType,
                types: selectedTypes,
                villa_type: (!isEmpty(selectedDealType) && !isEmpty(selectedTypes) && selectedTypes.length === 1) ? state.villa_type.selected_items : [],
                facilities: !isEmpty(selectedDealType) ? state.facilities.selected_items : [],
                deeds: !isEmpty(selectedDealType) ? state.deeds.selected_items : [],
                floors: !isEmpty(selectedDealType) ? state.floors.selected_items : [],
                bedrooms: !isEmpty(selectedDealType) ? state.bedrooms.selected_items : [],
                densities: !isEmpty(selectedDealType) ? state.densities.selected_items : [],
                min_price: !isEmpty(selectedDealType) ? state.price.selected_range.min : null,
                max_price: !isEmpty(selectedDealType) ? state.price.selected_range.max : null,
                min_mortgage: !isEmpty(selectedDealType) ? state.mortgage.selected_range.min : null,
                max_mortgage: !isEmpty(selectedDealType) ? state.mortgage.selected_range.max : null,
                min_rent: !isEmpty(selectedDealType) ? state.rent.selected_range.min : null,
                max_rent: !isEmpty(selectedDealType) ? state.rent.selected_range.max : null,
                min_land_area: !isEmpty(selectedDealType) ? state.land_area.selected_range.min : null,
                max_land_area: !isEmpty(selectedDealType) ? state.land_area.selected_range.max : null,
                min_infrastructure_area: !isEmpty(selectedDealType) ? state.infrastructure_area.selected_range.min : null,
                max_infrastructure_area: !isEmpty(selectedDealType) ? state.infrastructure_area.selected_range.max : null,
                min_age: !isEmpty(selectedDealType) ? state.age.selected_range.min : null,
                max_age: !isEmpty(selectedDealType) ? state.age.selected_range.max : null,
                loan: !isEmpty(selectedDealType) ? state.loan.checked : false,
                has_media: state.has_media.checked,
                has_video: state.has_video.checked,
                has_pool: state.has_pool.checked,
            };

            return setFiltersByParam(state, cityChangeParams);
        case "DISTRICTS_OPTIONS":
            handleFilters('district_id', action.payload.selected_items);
            const newDistricts = action.payload;
            const selectedDistricts = pluckKeyToArray(newDistricts.selected_items, 'value');
            newDistricts.selected_items = selectedDistricts;

            return {
                ...state,
                districts: action.payload,
                waiting: {
                    city: state.waiting.city,
                    district: false,
                    deal_type: state.waiting.deal_type,
                    types: state.waiting.types,
                },
                selected_filters: selected_filters,
            };
        case "DEAL_TYPE_OPTIONS":
            const cityId = state.cities.selected_items[0];
            let NewDealType = action.payload.deal_type.selected_items[0];
            state.types = action.payload.types;

            state.deal_type = action.payload.deal_type;

            const params = {
                city_id: cityId,
                deal_type: NewDealType,
                types: state.types.selected_items,
                villa_type: [],
                facilities: state.facilities.selected_items,
                deeds: [],
                floors: [],
                bedrooms: [],
                densities: [],
                min_price: null,
                max_price: null,
                min_mortgage: null,
                max_mortgage: null,
                min_rent: null,
                max_rent: null,
                min_land_area: null,
                max_land_area: null,
                min_infrastructure_area: null,
                max_infrastructure_area: null,
                min_age: null,
                max_age: null,
                loan: false,
                has_media: state.has_media.checked,
                has_video: state.has_video.checked,
                has_pool: false,
                waiting: {
                    city: state.waiting.city,
                    district: state.waiting.district,
                    deal_type: false,
                    types: state.waiting.types,
                },
            };

            return setFiltersByParam(state, params);

        case "TYPES_OPTIONS":
            state.types = action.payload;

            const typeParams = {
                city_id: state.cities.selected_items[0],
                deal_type: state.deal_type.selected_items[0],
                types: action.payload.selected_items,
                villa_type: [],
                facilities: state.facilities.selected_items ?? [],
                deeds: state.deeds.selected_items ?? [],
                floors: state.floors.selected_items ?? [],
                bedrooms: state.bedrooms.selected_items ?? [],
                densities: [],
                min_price: state.price.selected_range.min,
                max_price: state.price.selected_range.max,
                min_mortgage: state.mortgage.selected_range.min,
                max_mortgage: state.mortgage.selected_range.max,
                min_rent: state.rent.selected_range.min,
                max_rent: state.rent.selected_range.max,
                min_land_area: null,
                max_land_area: null,
                min_infrastructure_area: null,
                max_infrastructure_area: null,
                min_age: null,
                max_age: null,
                loan: false,
                has_media: state.has_media.checked,
                has_video: state.has_video.checked,
                has_pool: false,
                waiting: {
                    city: state.waiting.city,
                    district: state.waiting.district,
                    deal_type: state.waiting.deal_type,
                    types: false,
                },
            };

            return setFiltersByParam(state, typeParams);

        case "VILLA_TYPE_OPTIONS":
            handleFilters('villa_types', action.payload.selected_items);

            return {
                ...state,
                villa_type: action.payload,
                selected_filters: selected_filters,
            };
        case "FACILITIES_OPTIONS":
            const selectedFacilities = [...action.payload.selected_items];

            for (let otherFacility of otherFacilityFilters) {
                delete selected_filters[otherFacility];
            }

            const otherFacilityFiltersSelected = action.payload.otherFacilityFilters;
            for (let otherFacilitySelected of otherFacilityFiltersSelected) {
                handleFilters(otherFacilitySelected, 1);

                const index = selectedFacilities.indexOf(otherFacilitySelected);
                if (index !== -1) {
                    delete selectedFacilities[index]
                }
            }

            handleFilters('facilities', array_unique(selectedFacilities));

            return {
                ...state,
                facilities: action.payload,
                selected_filters: selected_filters,
            };

        case "DEED_OPTIONS":
            handleFilters('deeds', action.payload.selected_items);
            return {
                ...state,
                deeds: action.payload,
                selected_filters: selected_filters,
            };
        case "FLOORS_OPTIONS":
            handleFilters('floors', action.payload.selected_items);
            return {
                ...state,
                floors: action.payload,
                selected_filters: selected_filters,
            };
        case "BEDROOM_COUNT_OPTIONS":
            handleFilters('bedrooms', action.payload.selected_items);
            return {
                ...state,
                bedrooms: action.payload,
                selected_filters: selected_filters,
            };
        case "DENSITY_OPTIONS":
            handleFilters('densities', action.payload.selected_items);
            return {
                ...state,
                densities: action.payload,
                selected_filters: selected_filters,
            };
        case "PRICES_OPTIONS":
            handleFilters('min_price', action.payload.selected_range.min);
            handleFilters('max_price', action.payload.selected_range.max);

            return {
                ...state,
                price: {
                    show: checkVisibleFilter(state.deal_type.selected_items[0], state.types.selected_items, 'price'),
                    options: state.price.options,
                    selected_range: action.payload.selected_range
                },
                selected_filters: selected_filters,
            };
        case "MORTGAGE_OPTIONS":
            handleFilters('min_mortgage', action.payload.selected_range.min);
            handleFilters('max_mortgage', action.payload.selected_range.max);

            return {
                ...state,
                mortgage: {
                    show: checkVisibleFilter(state.deal_type.selected_items[0], state.types.selected_items, 'mortgage'),
                    options: state.mortgage.options,
                    selected_range: action.payload.selected_range
                },
                selected_filters: selected_filters,
            };
        case "RENT_OPTIONS":
            handleFilters('min_rent', action.payload.selected_range.min);
            handleFilters('max_rent', action.payload.selected_range.max);
            return {
                ...state,
                rent: {
                    show: checkVisibleFilter(state.deal_type.selected_items[0], state.types.selected_items, 'rent'),
                    options: state.rent.options,
                    selected_range: action.payload.selected_range
                },
                selected_filters: selected_filters,
            };
        case "LAND_AREA_OPTIONS":
            handleFilters('min_land_area', action.payload.selected_range.min);
            handleFilters('max_land_area', action.payload.selected_range.max);
            return {
                ...state,
                land_area: {
                    show: checkVisibleFilter(state.deal_type.selected_items[0], state.types.selected_items, 'land_area'),
                    options: state.land_area.options,
                    selected_range: action.payload.selected_range
                },
                selected_filters: selected_filters,
            };
        case "INFRASTRUCTURE_AREA_OPTIONS":
            handleFilters('min_infrastructure_area', action.payload.selected_range.min);
            handleFilters('max_infrastructure_area', action.payload.selected_range.max);
            return {
                ...state,
                infrastructure_area: {
                    show: checkVisibleFilter(state.deal_type.selected_items[0], state.types.selected_items, 'infrastructure_area'),
                    options: state.infrastructure_area.options,
                    selected_range: action.payload.selected_range
                },
                selected_filters: selected_filters,
            };
        case "AGE_OPTIONS":
            handleFilters('min_age', action.payload.selected_range.min);
            handleFilters('max_age', action.payload.selected_range.max);
            return {
                ...state,
                age: {
                    show: checkVisibleFilter(state.deal_type.selected_items[0], state.types.selected_items, 'age'),
                    options: state.age.options,
                    selected_range: action.payload.selected_range
                },
                selected_filters: selected_filters,
            };
        case "LOAN":
            handleFilters('loan', action.payload);
            return {
                ...state,
                loan: {
                    show: checkVisibleFilter(state.deal_type.selected_items[0], state.types.selected_items, 'loan'),
                    checked: action.payload
                },
                selected_filters: selected_filters,
            };
        case "HAS_MEDIA":
            handleFilters('has_media', action.payload);
            return {
                ...state,
                has_media: {
                    show: true,
                    checked: action.payload
                },
                selected_filters: selected_filters,
            };
        case "HAS_VIDEO":
            handleFilters('has_video', action.payload);
            return {
                ...state,
                has_video: {
                    show: true,
                    checked: action.payload
                },
                selected_filters: selected_filters,
            };
        case "HAS_POOL":
            handleFilters('has_pool', action.payload);
            return {
                ...state,
                has_pool: {
                    show: true,
                    checked: action.payload
                },
                selected_filters: selected_filters,
            };
        case 'SORTS':
            const sort = action.payload;
            handleFilters('sort', sort);
            const sorts = [...state.sorts];

            for (let item of sorts) {
                item.active = (item.name === sort);
            }

            return {
                ...state,
                sorts: sorts,
                selected_filters: selected_filters,
            };
        case 'SET_LOADINGS' :
            return {
                ...state,
                loadings: action.payload
            };

        case 'SELECTED_FILTERS' :
            const selectedFilters = action.payload;
            const selectedFacilitiesFilters = !isEmpty(selectedFilters['facilities']) ? selectedFilters['facilities'] : [];

            if (!isEmpty(selectedFilters['one_unit_in_floor']) && selectedFilters['one_unit_in_floor'] === 1) {
                selectedFacilitiesFilters.push('one_unit_in_floor')
            }

            if (!isEmpty(selectedFilters['without_landlord']) && selectedFilters['without_landlord'] === 1) {
                selectedFacilitiesFilters.push('without_landlord')
            }
            const selectedFiltersParams = {
                city_id: selectedFilters.city_id ?? '',
                deal_type: selectedFilters.deal_type ?? '',
                types: selectedFilters.types ?? [],
                min_price: selectedFilters.min_price ?? '',
                max_price: selectedFilters.max_price ?? '',
                min_mortgage: selectedFilters.min_mortgage ?? '',
                max_mortgage: selectedFilters.max_mortgage ?? '',
                min_rent: selectedFilters.min_rent ?? '',
                max_rent: selectedFilters.max_rent ?? '',
                loan: selectedFilters.loan ?? false,
                has_media: selectedFilters.has_media ?? false,
                has_video: selectedFilters.has_video ?? false,
                has_pool: selectedFilters.has_pool ?? false,
                waiting: selectedFilters.waiting ?? [],
                sort: selectedFilters.sort ?? '',
                villa_type: !isEmpty(selectedFilters.villa_types) ? selectedFilters.villa_types : (selectedFilters.villa_type ?? ''),
                facilities: selectedFacilitiesFilters,
                deeds: selectedFilters.deeds ?? [],
                floors: selectedFilters.floors ?? [],
                bedrooms: selectedFilters.bedrooms ?? [],
                densities: selectedFilters.densities ?? [],
                min_land_area: selectedFilters.min_land_area ?? '',
                max_land_area: selectedFilters.max_land_area ?? '',
                min_infrastructure_area: selectedFilters.min_infrastructure_area ?? '',
                max_infrastructure_area: selectedFilters.max_infrastructure_area ?? '',
                min_age: selectedFilters.min_age ?? '',
                max_age: selectedFilters.max_age ?? '',
            };

            return setFiltersByParam(state, selectedFiltersParams);
        case 'RESET_FILTERS' :
            const device = action.payload;

            const DealTypeValue = (device === 'desktop') ? state.deal_type.selected_items[0] : '';
            const TypesValue = (device === 'desktop') ? state.types.selected_items : [];

            state = handleDealTypeParams(state, DealTypeValue, TypesValue);

            state.districts = UpdateSelectionOptions(state.districts.options, {items: (device === 'desktop') ? state.districts.selected_items : []});
            handleFilters('district_id', (device === 'desktop') ? state.districts.selected_items : []);

            const resetParams = {
                city_id: state.cities.selected_items[0],
                deal_type: DealTypeValue,
                types: TypesValue,
                min_price: (device === 'desktop') ? state.price.selected_range.min : '',
                max_price: (device === 'desktop') ? state.price.selected_range.max : '',
                min_mortgage: (device === 'desktop') ? state.mortgage.selected_range.min : '',
                max_mortgage: (device === 'desktop') ? state.mortgage.selected_range.max : '',
                min_rent: (device === 'desktop') ? state.rent.selected_range.min : '',
                max_rent: (device === 'desktop') ? state.rent.selected_range.max : '',
                loan: (device === 'desktop') ? state.loan.checked : false,
                has_media: (device === 'desktop') ? state.has_media.checked : false,
                has_video: (device === 'desktop') ? state.has_video.checked : false,
                has_pool: false,
                villa_type: [],
                facilities: [],
                deeds: [],
                floors: [],
                bedrooms: [],
                densities: [],
                min_land_area: null,
                max_land_area: null,
                min_infrastructure_area: null,
                max_infrastructure_area: null,
                min_age: null,
                max_age: null,
            };

            return setFiltersByParam(state, resetParams);

        default:
            return state;
    }
};


function setFiltersByParam(state, params) {
    let cityId = getDefaultCity();

    let citiesNewOption = state.cities;
    let dealTypeNewOption = state.deal_type;
    let TypesNewOption = state.types;

    let VillaTypeOption = state.villa_type;
    let facilitiesNewOption = state.facilities;
    let deedNewOption = state.deeds;
    let floorsNewOption = state.floors;
    let bedroomsNewOption = state.bedrooms;
    let densitiesNewOption = state.densities;
    let newLoan = state.loan;
    let newHasMedia = state.has_media;
    let newHasVideo = state.has_video;
    let newWaiting = state.waiting;
    let newSorts = state.sorts;
    let newHasPool = state.has_pool;

    const DealType = params.deal_type;
    let Types = [];

    if (!isEmpty(params['types'])) {
        Types = params['types'];
    }


    Object.keys(params).forEach(key => {
        const value = params[key];

        switch (key) {
            case 'city_id':
                cityId = params.city_id;
                citiesNewOption = UpdateSelectionOptions(state.cities.options, {items: [cityId]});
                handleFilters('city_id', cityId);
                break;

            case 'deal_type':

                state = handleDealTypeParams(state, DealType, Types);
                dealTypeNewOption = UpdateSelectionOptions(state.deal_type.options, {items: [DealType]});
                facilitiesNewOption = handleFacilitiesLists(DealType, Types);

                handleFilters('deal_type', DealType);
                break;

            case 'types':
                TypesNewOption = UpdateSelectionOptions(state.types.options, {items: Types});

                if (!isEmpty(params.deal_type)) {
                    facilitiesNewOption = handleFacilitiesLists(params.deal_type, Types)
                }
                handleFilters('types', Types);
                break;

            case 'villa_type':
                const villaType = params['villa_type'];

                VillaTypeOption = UpdateSelectionOptions(state.villa_type.options, {items: [villaType]});

                VillaTypeOption.show = checkVisibleFilter(DealType, Types, 'villa_type');

                handleFilters('villa_types', villaType);
                break;

            case 'deeds':
                const deedsVisibility = checkVisibleFilter(DealType, Types, 'deeds');
                const Deeds = deedsVisibility ? params['deeds'] : [];
                deedNewOption = UpdateSelectionOptions(state.deeds.options, {items: Deeds});
                deedNewOption.show = deedsVisibility;
                handleFilters('deeds', Deeds);
                break;

            case 'floors':
                const floorsVisibility = checkVisibleFilter(DealType, Types, 'floors');
                const Floors = floorsVisibility ? params['floors'] : [];
                floorsNewOption = UpdateSelectionOptions(state.floors.options, {items: Floors});
                floorsNewOption.show = floorsVisibility;
                handleFilters('floors', Floors);
                break;

            case 'bedrooms':
                const bedroomsVisibility = checkVisibleFilter(DealType, Types, 'bedrooms');
                const Bedrooms = bedroomsVisibility ? params['bedrooms'] : [];
                bedroomsNewOption = UpdateSelectionOptions(state.bedrooms.options, {items: Bedrooms});
                bedroomsNewOption.show = bedroomsVisibility;
                handleFilters('bedrooms', Bedrooms);
                break;

            case 'densities':
                const Densities = params['densities'];
                densitiesNewOption = UpdateSelectionOptions(state.densities.options, {items: Densities});
                densitiesNewOption.show = checkVisibleFilter(DealType, Types, 'densities');
                handleFilters('densities', Densities);
                break;

            case 'facilities':
                facilitiesNewOption = handleFacilitiesLists(DealType, Types);

                for (let otherFacility of otherFacilityFilters) {
                    delete selected_filters[otherFacility];
                }

                for (let item of facilitiesNewOption.options) {
                    item.checked = false;
                    for (let facilityKey in params['facilities']) {
                        const selected = params['facilities'][facilityKey];

                        if (selected === item.value && item.show) {
                            item.checked = true;

                            if (inArray(item.value, otherFacilityFilters)) {
                                handleFilters(item.value, 1);
                                delete params['facilities'][facilityKey];
                            }
                        } else if (selected === item.value && !item.show) {
                            item.checked = false;

                            delete params['facilities'][facilityKey];
                            params['facilities'] = array_unique(params['facilities']);
                        }
                    }
                }

                facilitiesNewOption.selected_items = params['facilities'];
                facilitiesNewOption['show'] = (params['facilities'].length) ? true : facilitiesNewOption.show;
                handleFilters('facilities', array_unique(params['facilities']));

                break;

            case 'loan':
                handleFilters('loan', (params['loan']));
                newLoan = {
                    show: checkVisibleFilter(DealType, Types, 'loan'),
                    checked: (params['loan'])
                };

                break;

            case 'has_media' :
                handleFilters('has_media', (params['has_media']));
                newHasMedia = {
                    show: true,
                    checked: (params['has_media'])
                };
                break;

            case 'has_video' :
                handleFilters('has_video', (params['has_video']));
                newHasVideo = {
                    show: true,
                    checked: (params['has_video'])
                };
                break;

            case 'has_pool' :
                const hasPoolVisibility = checkVisibleFilter(DealType, Types, 'has_pool');

                handleFilters('has_pool', (params['has_pool']));

                newHasPool = {
                    show: hasPoolVisibility,
                    checked: (params['has_pool'])
                };

                break;

            case 'waiting' :
                newWaiting = params['waiting'];
                break;

            case 'sort' :
                let sort = params['sort'];

                handleFilters('sort', sort);

                if (isEmpty(sort)) {
                    sort = 'boosted_at'
                }

                for (let item of newSorts) {
                    item.active = (item.name === sort);
                }

                break;
        }
    });

    let priceNew = selectedRange(params, state, 'price');
    let mortgageNew = selectedRange(params, state, 'mortgage');
    let rentNew = selectedRange(params, state, 'rent');
    let land_areaNew = selectedRange(params, state, 'land_area');
    let infrastructure_areaNew = selectedRange(params, state, 'infrastructure_area');
    let ageNew = selectedRange(params, state, 'age');

    return {
        ...state,
        cities: citiesNewOption,
        deal_type: dealTypeNewOption,
        types: TypesNewOption,
        villa_type: VillaTypeOption,
        facilities: facilitiesNewOption,
        deeds: deedNewOption,
        floors: floorsNewOption,
        bedrooms: bedroomsNewOption,
        densities: densitiesNewOption,
        price: priceNew,
        mortgage: mortgageNew,
        rent: rentNew,
        land_area: land_areaNew,
        infrastructure_area: infrastructure_areaNew,
        age: ageNew,
        loan: newLoan,
        has_media: newHasMedia,
        has_video: newHasVideo,
        has_pool: newHasPool,
        waiting: newWaiting,
        sorts: newSorts,
        selected_filters: selected_filters,
    };
}

function selectedRange(params, state, name = 'price') {
    let min = '';
    let max = '';

    if (!isEmpty(params['min_' + name])) {
        min = params['min_' + name];
        handleFilters('min_' + name, min);
    }

    if (!isEmpty(params['max_' + name])) {
        max = params['max_' + name];
        handleFilters('max_' + name, max);
    }

    return {
        show: checkVisibleFilter(params.deal_type, params.types, name),
        options: state[name]['options'],
        selected_range: {min: min, max: max}
    }
}